var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionTrackAdd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.586 5.828A2 2 0 0 1 17 7.243v2.819a8.069 8.069 0 0 1 2 0v-2.82a4 4 0 1 0-8 0v6.882a8.038 8.038 0 0 1 2-2.37V7.244a2 2 0 0 1 .586-1.415Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18.49v2.141a3.998 3.998 0 0 1-5-3.874V11c0-.056.005-.112.014-.166a3.001 3.001 0 1 1 1.972 0c.01.054.014.11.014.166v5.757a2 2 0 0 0 3 1.733ZM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M24 18a6 6 0 1 1-12 0 6 6 0 0 1 12 0Zm-7-4v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionTrackAdd);
export default __webpack_public_path__ + "static/media/ic_action_track_add.708c443e5479260a408d2c9474ea8040.svg";
export { ForwardRef as ReactComponent };